import * as React from 'react'
import { Link } from 'react-router-dom'
import { LucideIcon } from 'utils/lucideIcon'
import { SECTION } from 'capacity/copy'

interface CapacityTopBarProps {
    backTo: string
    reportTo?: string
    children?: React.ReactNode
}

export function CapacityTopBar({ backTo, reportTo, children }: CapacityTopBarProps) {
    return (
        <div className="capacity-topbar">
            <div className="capacity-topbar-links">
                <Link to={backTo} className="capacity-back-link">
                    <LucideIcon iconName="ArrowLeft" size={16} />
                    {SECTION.backToList}
                </Link>
                {reportTo && (
                    <Link to={reportTo} className="capacity-report-link">
                        {SECTION.reportLink}
                    </Link>
                )}
            </div>
            {children}
        </div>
    )
}
